import { privateApi } from "@core/libs/axios/apiInstances";
import { handlePaginatedResponse } from "@core/libs/axios/serviceHandler";
import { UserWorkspaceSchema } from "../types";
import type { TUserWorkspace, UserWorkspacesData } from "../types";

const mapUserWorkspace = (item: TUserWorkspace): TUserWorkspace => item;

export async function getUserWorkspaces(
  signal?: AbortSignal,
): Promise<UserWorkspacesData> {
  return handlePaginatedResponse(
    privateApi.get("/workspace/", { signal }),
    UserWorkspaceSchema,
    mapUserWorkspace,
  ) as Promise<UserWorkspacesData>;
}
